/**
 * @file custom.datepipe.ts
 * @author Codeforce
 * @date 23 Mar 2020
 * @copyright 2020 Bisnode Deutschland GmbH
 * @brief convert US datetype to German datetype
 */
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'customDate'
})

export class CustomDatePipe extends
  DatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if(args == null){
      args = "dd.MM.yyyy HH:mm:ss";
    }
    return super.transform(value, args);
  }
}
